import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import { useMediaQuery, useTheme } from '@mui/material';
const MainRouter = () => {
	return (
		<div>
			<Routes>
				<Route path='/' exact element={<LandingPage />} />
			</Routes>
		</div>
	);
};

export default MainRouter;
